/*jslint node: true, browser: true*/
"use strict";

var dependentRequiredBehaviour = require("../ko-behaviours-dependentrequired");
var ko = require("pli/knockout");
var multiselectBehaviour = require("pli/forms-knockoutcontrols-multiselect");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");
var picklistItemExtensions = require("../picklist-common/picklistItemViewModelExtensions");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Zone View Model
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function ZoneViewModel(form) {
    this.initPicklistItem("Geo-Zone-", form);

    this.code = this.id = pliObservable(null, null, "required");
    this.description = pliObservable("");
    this.isGroup = ko.observable(false);
    this.baseZones = pliObservable(null, { trigger: this.isGroup, expectedValue: true, picklistData: entityRegistry.zoneBase }, dependentRequiredBehaviour, multiselectBehaviour);
    this.startAge = pliObservable(null, "N2", "numeric");
    this.endAge = pliObservable(null, "N2", "numeric");

    this.extras.displayName = ko.computed(ZoneViewModel.prototype._computeDisplayName, this);
    this.extras.isFixed = ko.observable(false);

    this.extras.isFixed.subscribe(function (isFixedValue) {
        if (isFixedValue) {
            this.extras.message("This is a standardized zone, it cannot be modified.");
        }
    }, this);

    ko.computed(ZoneViewModel.prototype._computeZoneAges, this);
}


//-------------------------------------------
ZoneViewModel.prototype.fromCacheItem = function zoneFromCacheItem(item) {
    var record;
    if (item && item.length) {
        record = {
            guid: item[item.length - 1],
            code: item[0],
            description: item[1],
            startAge: item[2],
            endAge: item[3],
            isGroup: item[4],
            isFixed: item[5]
        };

        // If record is a group zone, we need to query db for the base zones
        // Setting the state to "loading" will make a PLI call to get the
        // rest of the details.
        if (record.isGroup) {
            this.extras.state("loading");
        }

    } else {
        record = item;

        // splits the string into an array of string values
        if (record && typeof record.baseZones === "string") {
            record.baseZones = record.baseZones.split(', ');
        }
    }
    return record;
};


//-------------------------------------------
ZoneViewModel.prototype.load = function loadZone(record) {
    if (window.console && window.console.group) { window.console.group("ZoneViewModel.loadViewModel", record); }

    record = record || {};

    this.code.reset();
    this.description.reset();
    this.baseZones.reset();
    this.startAge.reset();
    this.endAge.reset();
    this.extras.isFixed(false);

    this.guid(record.guid || null);
    this.code.load(record.code);
    this.description.load(record.description);
    this.isGroup(!!record.isGroup);
    this.baseZones.load(record.baseZones);
    this.startAge.load(record.startAge);
    this.endAge.load(record.endAge);

    this.extras.isFixed(!!record.isFixed);

    if (window.console && window.console.groupEnd) { window.console.groupEnd(); }
};


//-------------------------------------------
ZoneViewModel.prototype._computeZoneAges = function computeZoneAges() {
    var selectedBaseZones = this.baseZones(),
        baseZoneDataList = entityRegistry.zoneBase.picklistData.peek();

    // compute zone ages based on the max and min of the base zones
    if (selectedBaseZones && baseZoneDataList) {
        var result = ko.utils.arrayFilter(baseZoneDataList.data.items, function (item) {
            return ko.utils.arrayFirst(selectedBaseZones, function (selected) {return selected === item[0]; }) !== null;
        });

        var startAges = result.map(function (resultItem) { return Number(resultItem[2]); });
        var endAges = result.map(function (resultItem) { return Number(resultItem[3]); });

        if (startAges && endAges) {
            this.startAge.load(Math.min.apply(Math, startAges));
            this.endAge.load(Math.max.apply(Math, endAges));
        }
    }
};


//-------------------------------------------
ZoneViewModel.prototype._computeDisplayName = function computeZoneDisplayName() {
    var id = this.id();
    return (id ? "Zone ".concat(id) : "(No zone name yet)");
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
var zoneForm = pli.forms.registry.zoneForm;

if (typeof zoneForm !== "object") { throw new Error("Zone form element could not be found - did you render it using CreateZoneForm?"); }
if (zoneForm.viewModel) { throw new Error("Zone form has already been initialized"); }

ko.utils.extend(ZoneViewModel.prototype, picklistItemExtensions.mixins);
zoneForm.viewModel = new ZoneViewModel(zoneForm);

entityRegistry.zone.open.create = entityRegistry.zone.open.edit = zoneForm.viewModel.open;
entityRegistry.zone.getPicklistBehaviourData = function getPicklistBehaviourData() {
    return {
        onNewItem: zoneForm.viewModel.open,
        onOpenItem: zoneForm.viewModel.open,
        picklistData: dataCache.getObservable("zone")
    };
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = ZoneViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/picklist-zone/zoneViewModel.js
// module id = 648
// module chunks = 49